import React from 'react';
import Column from 'components/ui/show/Column';
import ConfigurationInputField from './ConfigurationInputField';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import InnerColumn from 'components/ui/show/InnerColumn';
import PropTypes from 'prop-types';
import Section from 'components/ui/general/Section';
import Table from 'components/ui/table/Table';
import TableRow from 'components/ui/table/TableRow';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { compose } from 'recompose';
import differenceWith from 'lodash/differenceWith';
import isEqualWith from 'lodash/isEqualWith';

class ObjectConfiguration extends React.Component {
    shouldComponentUpdate(nextProps) {
        return (this.props.values !== nextProps.values ||
            !utils.isEmpty(differenceWith(nextProps.values, this.props.values, isEqualWith))) || nextProps.errors !== this.props.errors;
    }

    onChange = (event) => {
        const { onChange, name } = this.props;

        return onChange(name, event.target.name, event.target.value);
    }

    getFieldInputStyle = (fieldName) => {
        const {
            fieldInputWrapperStyles,
        } = this.props;

        return fieldInputWrapperStyles[fieldName] || null;
    };

    render() {
        const {
            component: TableCellComponent,
            components,
            errors,
            fields,
            id,
            inputComponentProps,
            name,
            translate,
            values,
            title,
        } = this.props;

        return (
            <Section>
                <Column
                    errorMessage={ errors[name] || '' }
                    title={ title }
                >
                    <InnerColumn>
                        <Table id={ id } responsive='scroll'>
                            <TableRow>
                                {
                                    utils.map(fields, (field) => {
                                        const width = `${ (100 - 5) / fields.length }%`;

                                        return (
                                            <HeaderColumn
                                                key={ `header-${ field }` }
                                                style={ { width: width } }
                                            >
                                                { translate(`resources.products.fields.${ name }.${ field }`) }
                                            </HeaderColumn>
                                        );
                                    })
                                }
                            </TableRow>

                            <TableRow>
                                {
                                    utils.map(fields, (field, index) => {
                                        const fieldWrapperStyle = this.getFieldInputStyle(field);
                                        const props = {
                                            key: `cell-${ name }-${ field }`,
                                            ...(fieldWrapperStyle && { inputWrapperStyle: fieldWrapperStyle }),
                                            name: field,
                                            onChangeInput: this.onChange,
                                            placeholder: translate(`resources.products.fields.${ name }.${ field }_placeholder`),
                                            style: {
                                                paddingLeft: index === 0 ? 12 : 0,
                                            },
                                            value: values || {},
                                            ...inputComponentProps,
                                        };

                                        if (components && components[field]) {
                                            return React.cloneElement(components[field], props);
                                        }

                                        return <TableCellComponent { ...props } />;
                                    })
                                }
                            </TableRow>
                        </Table>
                    </InnerColumn>
                </Column>
            </Section>
        );
    }
}

ObjectConfiguration.defaultProps = {
    errors: {},
    fieldInputWrapperStyles: {},
    fields: [],
    inputComponentProps: {},
};

ObjectConfiguration.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.node,
    ]).isRequired,
    components: PropTypes.object,
    errors: PropTypes.object,
    fields: PropTypes.arrayOf(PropTypes.string),
    fieldInputWrapperStyles: PropTypes.object,
    id: PropTypes.string.isRequired,
    inputComponentProps: PropTypes.object,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string,
    values: PropTypes.object,
    title: PropTypes.string,
};

const enhance = compose(
    translate,
    ConfigurationInputField,
);

export default enhance(ObjectConfiguration);



// WEBPACK FOOTER //
// ./src/pages/products/configuration/ObjectConfiguration.js